var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-login u-mya"},[_c('TheButton',{staticClass:"c-login__button",nativeOn:{"click":function($event){return _vm.logout.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('TOPBAR_LOGOUT'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }